import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import type { Archetype, ArchetypeMatch } from '../../types/investmentPhilosophy';

interface IPSecondaryMatchesProps {
  matches: ArchetypeMatch[];
  archetypeMap: Record<string, Archetype>;
}

export const IPSecondaryMatches: React.FC<IPSecondaryMatchesProps> = ({
  matches,
  archetypeMap,
}) => {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  return (
    <div className="space-y-2">
      {matches.map((match) => {
        const archetype = archetypeMap[match.archetypeId];
        if (!archetype) return null;
        const isExpanded = expandedId === match.archetypeId;
        const isFaint = match.percentage < 5;
        return (
          <button
            key={match.archetypeId}
            onClick={() => setExpandedId(isExpanded ? null : match.archetypeId)}
            className={`w-full text-left rounded-xl px-4 py-3 transition-opacity ${
              isFaint ? 'opacity-60' : ''
            }`}
            style={{
              backgroundColor: 'var(--clue-bg-card)',
              border: '1px solid var(--clue-border-light)',
            }}
          >
            <div className="flex items-center gap-3">
              <div className="flex-1 flex items-center gap-3 min-w-0">
                <span
                  className="font-mono text-base font-bold w-12 shrink-0"
                  style={{ color: 'var(--clue-green-accent)' }}
                >
                  {match.percentage}%
                </span>
                <div className="min-w-0">
                  <p
                    className="font-serif text-base truncate"
                    style={{ color: 'hsl(var(--foreground))' }}
                  >
                    {archetype.name}
                  </p>
                  <p
                    className="font-mono text-[10px] uppercase tracking-wider truncate"
                    style={{ color: 'hsl(var(--muted-foreground))' }}
                  >
                    {archetype.descriptor}
                  </p>
                </div>
              </div>
              <ChevronDown
                className={`w-4 h-4 shrink-0 transition-transform ${
                  isExpanded ? 'rotate-180' : ''
                }`}
                style={{ color: 'hsl(var(--muted-foreground))' }}
              />
            </div>

            {isExpanded && (
              <p
                className="text-sm leading-relaxed mt-3 pt-3 border-t"
                style={{
                  color: 'hsl(var(--muted-foreground))',
                  borderColor: 'var(--clue-border-light)',
                }}
              >
                {archetype.bio}
              </p>
            )}
          </button>
        );
      })}
    </div>
  );
};
